import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { KeycloakInstance } from 'keycloak-js';
import { AvatarBuilder } from '@amplify/avatar-builder';
import kebabCase from 'lodash.kebabcase';
import { useTranslation } from 'react-i18next';

import { getAmpConfigFlags } from 'shared/config/amp-config';
import { AuthService } from 'shared/lib/keycloak';
import { useAppDispatch } from 'shared/lib/redux';
import { eventService } from 'shared/api/event-service';
import { Spinner } from 'shared/ui/spinner';
import { saveAvatar, useAvatarConfigSelector } from 'widgets/avatar';

import styles from './styles.module.scss';

export const AvatarBuilderPage = () => {
  const { t } = useTranslation();
  const kc = AuthService.getKC();

  const { avatarConfig } = useAvatarConfigSelector();

  const isAmpEventsInitializing = !eventService.ampEvents;

  const { isNewNavigationEnabled } = getAmpConfigFlags();

  const dispatch = useAppDispatch();

  const handleSaveAvatar = (characterAssets: null) =>
    dispatch(saveAvatar(characterAssets));

  return (
    <div
      className={clsx(styles.container, {
        [styles.containerWithNewNav]: isNewNavigationEnabled,
      })}
    >
      <div className={styles.header}>
        <Link to="/">
          <span className={styles.backLinkContent}>
            <i
              className={clsx('icon-v2-chevron-small-left', styles.icon)}
              aria-hidden
            />
            {t('Back')}
          </span>
        </Link>
        <h1 className={styles.title}>{t('Make your avatar')}</h1>
      </div>
      <div className={styles.builderWrapper}>
        {isAmpEventsInitializing ? (
          <Spinner isDark isLarge />
        ) : (
          <AvatarBuilder
            onAvatarLoad={handleSaveAvatar}
            config={{
              kc: kc ?? ({} as KeycloakInstance),
              ampEvents: eventService.ampEvents,
              appName: 'educator-home',
            }}
            assets={avatarConfig}
            isBig={true}
            isTeacher={true}
            LoadingComponent={<Spinner isDark isLarge />}
            xAPIEventsContextExtensions={{
              result: {
                'application-version':
                  kebabCase(import.meta.env.VITE_APP_VERSION) || '0-1-0',
              },
            }}
          />
        )}
      </div>
    </div>
  );
};
